import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {Causale} from "../../../_models/Causale";
import {SaveMessage} from "../../../_helpers/save-message";
import {OrganizzazioniService} from "../../../_services/organizzazioni.service";
import {CausaliService} from "../../../_services/causali.service";
import {SearchResult} from "../../../_models/SearchResult";

@Component({
    selector: 'app-select-causale',
    templateUrl: './select-causale.component.html',
    styleUrls: ['./select-causale.component.scss'],
    standalone: false
})
export class SelectCausaleComponent  implements OnInit {
  @Input() idCausale: number;
  @Output() idCausaleChange = new EventEmitter<number>();
  causali: Causale[] = [];
  loading = false;
  constructor(
    private saveMessage: SaveMessage,
    private causaliService: CausaliService,
    private organizzazioniService: OrganizzazioniService) { }

  ngOnInit() {
    this.getCausali();
  }

  getCausali = () => {
    this.loading = true;
    this.causaliService.getCausaliFilteredAsync(this.organizzazioniService.organizzazioneId
    ,'',0,0,'Codice',true)
      .then((_causali: SearchResult<Causale>) => this.causali = _causali.result)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento delle causali."))
      .finally(() => this.loading = false);
  };

  selectCausale = (e: SelectCustomEvent) => this.idCausaleChange.emit(+e.target.value);
}
